import React, {useState} from "react";
import PropTypes from "prop-types";
import {ReactComponent as Eye} from "../../../../assets/images/eye.svg";
import {ReactComponent as HiddenEye} from "../../../../assets/images/eyeHide.svg";
import "./Input.scss";

const Input = ({
  label = "",
  placeholder = "",
  type = "text",
  updateState,
  value = "",
  displayError = false,
  displayErrorMessage = "",
  valid = true,
  disabled = false,
  onKeyUp,
  min,
  max,
  detail
}) => {
  const [typeInput, setTypeInput] = useState(type);
  const handleChange = event => {
    updateState(event.target.value);
  };

  const handlePasswordDisplay = () => {
    setTypeInput(typeInput === "password" ? "text" : "password");
  };

  const eyeIcon = {
    password: <HiddenEye onClick={handlePasswordDisplay}/>,
    text: <Eye onClick={handlePasswordDisplay}/>
  };

  return (
    <div className="Input">
      <p className={displayError && !valid ? "visible" : null}>
        {value === "" ? "Campo obrigatório" : displayErrorMessage}
      </p>
      <div>
        {label ? <label>{label}</label> : null}
        <input
          className={displayError ? "invalid" : disabled ? "disabled" : ""}
          onChange={handleChange}
          placeholder={placeholder}
          type={typeInput}
          value={value}
          disabled={disabled}
          onKeyUp={onKeyUp}
          min={type === "date" ? min : null}
          max={type === "date" ? max : null}
        />
        {type === "password" ? eyeIcon[typeInput] : null}
      </div>
      {detail && <p className="detail">{detail}</p>}
    </div>
  );
};

Input.propTypes = {
  disabled: PropTypes.bool,
  displayError: PropTypes.bool,
  displayErrorMessage: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  updateState: PropTypes.func.isRequired,
  userProfile: PropTypes.bool,
  valid: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default Input;
